module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sd-single-view"
  }, [(_vm.result.length) ? _c('div', {
    staticClass: "sd-scrollable-div"
  }, [_c('div', {
    staticClass: "sd-content-card"
  }, [(this.$route.meta.jira || this.$route.meta.token) ? _c('jira-card', {
    attrs: {
      "displayMethod": 'single-ticket',
      "preloadedResult": _vm.result,
      "preloadedComments": _vm.commentsResults
    }
  }) : _vm._e(), _vm._v(" "), (this.$route.meta.confluence) ? _c('confluence-card', {
    attrs: {
      "preloadedResult": _vm.result
    }
  }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('loader-animation', {
    attrs: {
      "loader": _vm.loader,
      "isResults": _vm.result.length,
      "errorMessage": _vm.errorMsg
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-687ab8e5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/SingleView.vue
// module id = 432
// module chunks = 1